import i18n from "../i18n";

// Map i18n locales to Intl locale codes
const LOCALE_MAP: Record<string, string> = {
  en: "en-US",
  de: "de-DE",
};

/**
 * Get the current locale for Intl.DateTimeFormat
 */
export const getDateLocale = (): string => {
  return LOCALE_MAP[i18n.language] || "en-US";
};

/**
 * Format a date string for display
 */
export const formatDate = (
  dateString: string | null | undefined,
  style: "short" | "long" = "short",
): string => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleDateString(getDateLocale(), {
    year: "numeric",
    month: style === "long" ? "long" : "short",
    day: "numeric",
  });
};

/**
 * Format a date string with time for display
 */
export const formatDateTime = (
  dateString: string | null | undefined,
  style: "short" | "long" = "long",
): string => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleString(getDateLocale(), {
    year: "numeric",
    month: style === "long" ? "long" : "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
};
